import React, { useCallback } from 'react';
import BillingInputComponent from '../../../../template-blocks/billing-input/billing-input-component';
import billingInputTypes from '../../../../template-blocks/billing-input/billing-input-types';
import Icon from 'monday-ui-react-core/dist/Icon';
import Delete from 'monday-ui-react-core/dist/icons/Delete';
import { toFixed } from '../../../../../utils/number-utils';

export default function BillingItemComponent({
  id,
  description,
  quantity,
  price,
  onOrderItemBillingInputChange,
  onOrderItemDelete,
  previewMode,
  currencySign,
}) {
  const onBillingInputChange = useCallback(
    (inputId, inputData) => {
      onOrderItemBillingInputChange(id, { inputId, inputData: inputData.data });
    },
    [id, onOrderItemBillingInputChange]
  );

  const onDeleteClick = useCallback(() => {
    onOrderItemDelete(id);
  }, [id, onOrderItemDelete]);

  const total = `${currencySign}${toFixed(quantity * price)}`;

  return (
    <div key={id} className="row item pdf-row">
      <div className="col item-description">
        <BillingInputComponent
          id="description"
          previewMode={previewMode}
          withTitle={false}
          type={billingInputTypes.text}
          placeholder="Item description"
          value={description}
          onChange={onBillingInputChange}
        />
      </div>
      <div className="col item-quantity">
        <BillingInputComponent
          id="quantity"
          previewMode={previewMode}
          withTitle={false}
          type={billingInputTypes.number}
          placeholder="0"
          value={quantity}
          onChange={onBillingInputChange}
        />
      </div>
      <div className="col item-price">
        <BillingInputComponent
          id="price"
          previewMode={previewMode}
          withTitle={false}
          type={billingInputTypes.number}
          placeholder={`${currencySign}0.00`}
          value={price}
          label={`${currencySign}${price}`}
          onChange={onBillingInputChange}
        />
      </div>
      <div className="col item-total">
        <BillingInputComponent
          previewMode={previewMode}
          withTitle={false}
          type={billingInputTypes.text}
          disabled={true}
          placeholder={`${currencySign}0.00`}
          value={total}
        />
      </div>
      {!previewMode && (
        <div className="col item-delete">
          <Icon
            className="item-delete-icon-wrapper"
            iconType={Icon.type.SVG}
            icon={Delete}
            iconSize={20}
            onClick={onDeleteClick}
          />
        </div>
      )}
    </div>
  );
}
